import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from '../Services/cookie';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { InsuranceService, insuranceDetails } from '../Services/insurance.service';
import { AccountService } from '../Services/account.service';
import { AmountFormatterPipe } from '../pipes/amount-formatter.pipe';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-insurance',
  templateUrl: './insurance.component.html',
  standalone:false,
  styleUrls: ['./insurance.component.scss']
})
export class InsuranceComponent implements OnInit {

  emptyState: boolean = false;
  // Insurandash: any;
  Insurandash: any[] = [];
  selectedInsuDetail: insuranceDetails
  serviceType: string;

   carouselOptions: OwlOptions = {
    loop: false,
    nav: true,
    dots: true,
    items: 1,
    autoWidth: true,
    autoHeight: true,
    responsive: {
      0: { items: 1 },
      600: { items: 1 },
      1000: { items: 1 }
    }
  };

  constructor(private router: Router,private account: AccountService, private acct: AccountService, private insurance: InsuranceService, private common: CommonService, private cookieService: CookieService,
    private cdr: ChangeDetectorRef,
    public auth: AuthService ) { }

    // , private amountpipe:AmountFormatterPipe


  async ngOnInit(): Promise<any> {
    this.common.presentLoading();
    this.serviceType = await this.cookieService.get("sTyp", true);
    this.cdr.detectChanges();
    console.log("serviceTypeData", this.serviceType);
    this.auth.accessToken = await this.common.Get("token");
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
          if (data?.response?.code == 1) {
            this.acct.GetLoanDashboard(this.auth.accessToken).then((res: any) => {

              if (res?.response?.code == 1) {
                console.log("insurance",res);
                
                this.Insurandash = res.response.content.insuranceDetails;
                console.log(this.Insurandash,"Insurandash");
                

                if(this.Insurandash.length != 0){

                  this.selectedInsuDetail = this.Insurandash[0];

                
                  this.cookieService.set("proposalId", this.selectedInsuDetail.proposalId,true);

                  this.cookieService.set("InsuranceinternalId", this.selectedInsuDetail.internalId,true);

                  this.cookieService.set("Insurancenick", this.selectedInsuDetail.nickName,true);

                }
                else{

                  this.common.hideLoading();
                  // because no inusrane to show
                  // this.common.ParseErrorAlert("", "OK", this.router, res);
                }
             
                console.log("this.Insurandash", this.Insurandash);
                this.common.hideLoading();
              }
              else {
                this.common.hideLoading();
                this.common.ParseErrorAlert("", "OK", this.router, res);
              }
            })
          } else {
            await this.common.hideLoading();

            this.common.ParseErrorAlert("", "", this.router, data);
          }
        })
    
   this.cdr.detectChanges();
  }

  /**
   * Resolves the slide index from either an owl-carousel-o event payload
   * (SlidesOutputData: { startPosition, slides }) or a plain index passed by
   * internal callers such as selectCard(0).
   */
  private resolveCardIndex(e): number {
    if (typeof e === "number") {
      return e;
    }
    if (e && typeof e.startPosition === "number") {
      return e.startPosition;
    }
    return null;
  }

  selectCard(e) {
    const index = this.resolveCardIndex(e);
    // Guard: the cookie writes below dereference selectedInsuDetail directly.
    if (index == null || !this.Insurandash?.[index]) {
      return;
    }
    this.selectedInsuDetail = this.Insurandash[index];

    this.cookieService.set("proposalId", this.selectedInsuDetail.proposalId,true);
    this.cookieService.set("InsuranceinternalId", this.selectedInsuDetail.internalId,true);
    this.cookieService.set("Insurancenick", this.selectedInsuDetail.nickName,true);

  }

  selectMonth() {
  }

  onTrasactionsChange() {
  }

  back() {

  }

  userSwitch() {

   let body={
   ServiceType: "Conventional" 
    }
    this.common.presentLoading();
    this.account.UpdateServiceMode(body,this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("UpdateServiceModesucess",data);
          await this.getService()
          await this.common.hideLoading();
      
        } else {
          await this.common.hideLoading();
          this.common.ParseErrorAlert("", "", this.router, data);
        }
      });
  }

    async getService() {

    // await this.CommonService.presentLoading();
    this.account.GetServiceType({},this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("GetServiceTypesucess",data);

          this.serviceType=data?.response?.content?.serviceType
            this.cookieService.set(
            "sTyp",
            this.serviceType,
            true
          );
          await this.common.hideLoading();

          window.location.reload();
          } else {
          await this.common.hideLoading();
          this.common.ParseErrorAlert("", "", this.router, data);
        }
      });
  }



}
